export default {
  country_locale: 'es-ES',
  wia_title: 'Empecemos con el producto:',
  wia_need_help: 'Necesito ayuda con',
  wia_model_name: 'El modelo del producto es',
  wia_back: '< cambiar',
  wia_confirm: 'Enviar',
  wia_issue_search: '¿Cuál es el problema?',
  wia_issue_placeholder: 'Enter keywords',
  wia_issue_generic_macro_category: 'General',
  wia_issue_no_results: 'No results found!',
  wia_issue_search_label: 'Search',
  wia_issue_title: 'Manual search',
  wia_issue_concern: '¿Qué problema encontró?',
  wia_issue_specific: 'Algunos detalles más',
  wia_possible_solution: 'Posibles soluciones',
  wia_solved_issue: '¿Resolvió el problema?',
  wia_closed: 'Cerrar X',
  wia_feedback_ok: ' ¡Sí!',
  wia_find_another_solution: 'Pruebe otras soluciones.',
  wia_feedback_title: '¡Nos alegra que su problema esté resuelto!',
  wia_feedback_text1: 'Visite nuestra tienda y descubra las ofertas especiales dedicadas a usted',
  wia_feedback_text2: '',
  wia_smile_up_popup_text1: 'Descubre nuestros planes de protección',
  wia_smile_down_popup_title: '¿Aún necesita ayuda?',
  wia_smile_down_popup_text1: 'Ir al segundo paso',
  wia_smile_down_popup_or_text: 'o',
  wia_smile_down_popup_text2: 'Reserve una cita',
  wia_need_more_help: '¿Aún necesita ayuda?',
  wia_optional_label: '(opcional)',
  wia_no_solution: 'No pudimos encontrar una solución para su problema, pero no se preocupe, estamos aquí para ayudarlo. Haga clic aquí para obtener ayuda.',
  wia_all_solution: 'Todos los resultados',
  wia_all_categories: 'Todas las categorias',
  wia_seo_l1_issue: 'Todas las fallas por categoría',
  wia_seo_wp_country_name: 'España',
  wia_seo_bk_country_name: '',
  wia_seo_hp_country_name: 'ES',
  wia_seo_id_country_name: 'España',
  wia_seo_wp_meta_title: 'Problemas y soluciones',
  wia_seo_bk_meta_title: 'Problemas y soluciones',
  wia_seo_hp_meta_title: 'Problemas y soluciones',
  wia_seo_id_meta_title: 'Problemas y soluciones',
  wia_seo_wp_meta_description: '',
  wia_seo_bk_meta_description: '',
  wia_seo_hp_meta_description: '',
  wia_seo_id_meta_description: '',
  wia_seo_wp_meta_description_home: '',
  wia_seo_bk_meta_description_home: '',
  wia_seo_hp_meta_description_home: '',
  wia_seo_id_meta_description_home: ''
}
